import { VehicleState } from './types';
import { 
    getVehicleDescriptionLine as getVehicleDescriptionLine2, 
    getVehicleSummaryLine as getVehicleSummaryLine2, 
    getVehicleSpecLine as getVehicleSpecLine2,
    getVehicleTitle as getVehicleTitle2, 
    getVehicleDescriptionSecondaryLine as getVehicleDescriptionSecondaryLine2, 
    getVehicleDescriptionTertiaryLine as getVehicleDescriptionTertiaryLine2
} from '../../helpers'

export const getVehicleKms = (state: VehicleState) => state.vehicle.kms;
export const getVehicleRego = (state: VehicleState) => state.vehicle.rego;
export const getVehicleAustState = (state: VehicleState) => state.vehicle.auststate;

export const getVehicleRedbookCode = (state: VehicleState) => state.vehicle.redbookcode;
export const getVehicleVin = (state: VehicleState) => state.vehicle.matchDebug?.vin || '';
export const getVehicleFamily = (state: VehicleState) => state.vehicle.family || '';
export const getVehicleImage = (state: VehicleState) => state.vehicle.imageUrl || '';
export const getVehicleYear = (state: VehicleState) => state.vehicle.year || '';
export const getVehicleMake = (state: VehicleState) => state.vehicle.make || '';
export const getVehicleModel = (state: VehicleState) => state.vehicle.family || '';
export const getVehicleBadge = (state: VehicleState) => state.vehicle.badge || '';
export const getVehicleBadge2nd = (state: VehicleState) => state.vehicle.badge2nd || '';
export const getVehicleRbid = (state: VehicleState) => state.vehicle.rbid || '';
export const getVehicleMakecode = (state: VehicleState) => state.vehicle.makecode || '';

export const getVehicleFamilycode = (state: VehicleState) => state.vehicle.familycode || '';
export const getVehicleType = (state: VehicleState) => state.vehicle.vehicletype || '';
export const getVehicleMonth = (state: VehicleState) => state.vehicle.month || '';
export const getVehicleSequenceno = (state: VehicleState) => state.vehicle.sequenceno || '';
// export const getVehicleDescription = (state: VehicleState) => state.vehicle.description || '';
export const getVehicleNewvehicleflag = (state: VehicleState) => state.vehicle.newvehicleflag || '';
export const getVehicleImportflag = (state: VehicleState) => state.vehicle.importflag || '';
export const getVehicleLimitededition = (state: VehicleState) => state.vehicle.limitededition || '';
export const getVehicleSeries = (state: VehicleState) => state.vehicle.series || '';
export const getVehicleBodystyle = (state: VehicleState) => state.vehicle.bodystyle || '';
export const getVehicleDrive = (state: VehicleState) => state.vehicle.drive || '';
export const getVehicleGeartype = (state: VehicleState) => state.vehicle.geartype || '';
export const getVehicleGearlocation = (state: VehicleState) => state.vehicle.gearlocation || '';
export const getVehicleGearnum = (state: VehicleState) => state.vehicle.gearnum || '';
export const getVehicleDoornum = (state: VehicleState) => state.vehicle.doornum || '';
export const getVehicleEnginesize = (state: VehicleState) => state.vehicle.enginesize || '';
export const getVehicleEnginedesc = (state: VehicleState) => state.vehicle.enginedesc || '';
export const getVehicleCylinders = (state: VehicleState) => state.vehicle.cylinders || '';
export const getVehicleFueltype = (state: VehicleState) => state.vehicle.fueltype || '';
export const getVehicleInduction = (state: VehicleState) => state.vehicle.induction || '';
export const getVehicleCam = (state: VehicleState) => state.vehicle.cam || '';
export const getVehicleEnginetype = (state: VehicleState) => state.vehicle.enginetype || '';
export const getVehicleFuelcapacity = (state: VehicleState) => state.vehicle.fuelcapacity || '';
export const getVehicleFueldelivery = (state: VehicleState) => state.vehicle.fueldelivery;
export const getVehicleMethoddelivery = (state: VehicleState) => state.vehicle.methoddelivery || '';
export const getVehicleGvm = (state: VehicleState) => state.vehicle.gvm || '';
export const getVehicleWheelbase = (state: VehicleState) => state.vehicle.wheelbase || '';
export const getVehicleHeight = (state: VehicleState) => state.vehicle.height || '';
export const getVehicleLength = (state: VehicleState) => state.vehicle.length || '';
export const getVehicleWidth = (state: VehicleState) => state.vehicle.width || '';
export const getVehicleKerbweight = (state: VehicleState) => state.vehicle.kerbweight || '';
export const getVehicleTaremass = (state: VehicleState) => state.vehicle.taremass || '';
export const getVehiclePower = (state: VehicleState) => state.vehicle.power || '';
export const getVehiclePowerrpmto = (state: VehicleState) => state.vehicle.powerrpmto || '';
export const getVehicleTorque = (state: VehicleState) => state.vehicle.torque || '';
export const getVehicleTorquerpmfrom = (state: VehicleState) => state.vehicle.torquerpmfrom || '';
export const getVehicleTorquerpmto = (state: VehicleState) => state.vehicle.torquerpmto || '';
export const getVehicleSeatcapacity = (state: VehicleState) => state.vehicle.seatcapacity || '';
export const getVehicleAvgkm = (state: VehicleState) => state.vehicle.avgkm || '';
export const getVehicleGdkm = (state: VehicleState) => state.vehicle.gdkm || '';
export const getVehicleNewprice = (state: VehicleState) => state.vehicle.newprice || '';
export const getVehicleIsBestMatch = (state: VehicleState) => !!state.vehicle.isBestMatch;
export const getVehicleMatchDebug = (state: VehicleState) => state.vehicle.matchDebug;

export const getVehicleTitle = (state: VehicleState) => getVehicleTitle2(state.vehicle);
export const getVehicleDescriptionLine = (state: VehicleState) => getVehicleDescriptionLine2(state.vehicle);
export const getVehicleSecondaryLine = (state: VehicleState) => getVehicleDescriptionSecondaryLine2(state.vehicle);
export const getVehicleTertiaryLine = (state: VehicleState) => getVehicleDescriptionTertiaryLine2(state.vehicle);
export const getVehicleSummaryLine = (state: VehicleState) => getVehicleSummaryLine2(state.vehicle);
export const getVehicleSpecLine = (state: VehicleState) => getVehicleSpecLine2(state.vehicle);


